<template>
  <div style="overflow: hidden; width: 560px">
    <div class="field-group q-mt-sm">

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('name_upcase') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="name_input"
          :allow-line-break="false"
          v-model="theModel.Name"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('inn') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          :allow-line-break="false"
          v-model="theModel.INN"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('kpp') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          :allow-line-break="false"
          v-model="theModel.KPP"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('personal_account') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          :allow-line-break="false"
          v-model="theModel.Account"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('bank_account') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          :allow-line-break="false"
          v-model="theModel.bankAccount"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('bank_name') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          :allow-line-break="false"
          v-model="theModel.bankName"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('bik') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          :allow-line-break="false"
          v-model="theModel.BIK"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('bank_corr_account') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          :allow-line-break="false"
          v-model="theModel.corrAccount"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('legal_address') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          :allow-line-break="false"
          v-model="theModel.jurAddress"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('legal_form') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          :allow-line-break="false"
          v-model="theModel.legalUnit"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('comment') }}:</div>
        <native-input
          style="min-width: 200px;"
          ref="comment_input"
          v-model="theModel.Note"
          :edit-on-click="true"
          :show-border="true"
        />
      </div>

      <div class="field-group__row no-wrap q-mt-xs justify-between" style="align-items: end;">
        <div class="bold-name q-mr-xs">{{ $t('one_c_instance') }}:</div>
        <q-select
          flat
          v-model="theModel.instance1C"
          style="min-width: 200px; padding: 0 !important"
          class="thin-input"
          dropdown-icon="expand_more"
          fill-input
          :bottom-slots="false"
          dense
          outlined
          input-debounce="500"
          emit-value
          map-options
          ref="from_select"
          :options="instanceOptions"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import _ from "lodash";
import NativeInput from "@/components/common/basic/NativeInput.vue";
import { financesStore } from "@/store/finances";
import { reactive } from "vue";

export interface CounterpartyStructure {
  Name: string;
  INN: string;
  KPP: string;
  Account: string;
  bankAccount: string;
  bankName: string;
  BIK: string;
  corrAccount: string;
  jurAddress: string;
  legalUnit: string;
  Note: string;
  instance1C: string | null;
}

@Component({
  components: { NativeInput },
  emits: ["close", "update:modelValue"],
})
export default class CounterpartyCreateForm extends Vue {
  @Prop({ default: undefined })
  modelValue!: CounterpartyStructure;
  @Prop({ default: 0 })
  projectId!: number;

  finances_store: any = undefined;
  instances = reactive([])

  created() {
    this.finances_store = financesStore();
  }

  async mounted() {
    if (this.finances_store) {
      const opts = await this.finances_store.synchronizationGetInstances(this.projectId)
      
      if (opts?.List) {
        this.instances = opts.List.map(
          (el: string) => {
            return { label: el || this.$t('by_default'), value: el };
          }
        );
      }
    }
  }

  get theModel() {
    return this.modelValue;
  }

  @Watch("modelValue", { deep: true })
  model_changed(new_value: CounterpartyStructure) {
    this.$emit("update:modelValue", new_value);
  }

  get instanceOptions() {
    return this.instances;
  }

  close() {
    this.$emit("close", null);
  }
}
</script>

<style lang="scss"></style>
